<script setup>
import { useMediaQuery } from '@vueuse/core'
import { computed } from 'vue'
import { Carousel, Pagination, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

const isSmallScreen = useMediaQuery('(max-width: 425px)') // Up to 425px
const isMediumScreen = useMediaQuery(
	'(min-width: 426px) and (max-width: 768px)'
) // Between 426px and 768px
const isLargeScreen = useMediaQuery('(min-width: 769px)') // 769px and above

const itemsToShowComputed = computed(() => {
	if (isSmallScreen.value) {
		return 1.1
	} else if (isMediumScreen.value) {
		return 3.1
	} else if (isLargeScreen.value) {
		return 5.1
	} else {
		return 5.1
	}
})

const carouselConfig = {
	itemsToShow: itemsToShowComputed.value,
	wrapAround: true,
	height: 300,
}

const vehicleTypes = [
	{
		name: 'Hatch',
		imgSrc: '/assets/img/img-types-hatch.png',
	},
	{
		name: 'Compact SUV',
		imgSrc: '/assets/img/img-types-compact-suv.png',
	},
	{
		name: 'SUV',
		imgSrc: '/assets/img/img-types-suv.png',
	},
	{
		name: '7 Seater SUV',
		imgSrc: '/assets/img/img-types-7seatersuv.png',
	},
	{
		name: 'Premium Hatch',
		imgSrc: '/assets/img/img-types-premium-hatch.png',
	},
	{
		name: 'Premium Compact SUV',
		imgSrc: '/assets/img/img-types-premium-compact-suv.png',
	},
	{
		name: 'Premium SUV',
		imgSrc: '/assets/img/img-types-premium-suv.png',
	},
	{
		name: 'Premium Sedan',
		imgSrc: '/assets/img/img-types-premium-sedan.png',
	},
	{
		name: 'Premium EV',
		imgSrc: '/assets/img/img-types-premium-ev.png',
	},
]
</script>

<template>
	<section
		class="container bg-pattern bg-idrive-dark rounded-md py-10 md:py-20"
	>
		<div class="flex flex-col items-center justify-center overflow-hidden">
			<h2 class="text-white px-6">
				Vehicle range which offers something for every type of driver.
			</h2>

			<Carousel v-bind="carouselConfig">
				<Slide v-for="vehicle in vehicleTypes" :key="vehicle">
					<div class="carousel__item">
						<img
							width="200px"
							heigth="200px"
							:src="vehicle.imgSrc"
						/>
						<p class="font-bold">
							{{ vehicle.name }}
						</p>
					</div>
				</Slide>
				<template #addons>
					<Pagination />
				</template>
			</Carousel>
		</div>
	</section>
</template>
